import baseRoute from '../baseRoute';

export default `${baseRoute}/timeSheet` as const;
